module.exports = __webpack_public_path__ + "static/media/toggle_on.65d3c16d.svg";